import httpPortal from './http-portal'

class AntecipationRequest {
  get (id) {
    return httpPortal.get(`/private/api/antecipation_request/${id}`)
  }
}

export default new AntecipationRequest()



// WEBPACK FOOTER //
// ./src/services/antecipation_request.js